<div class="lane-attention-stack" *ngIf="alerts.length > 0" aria-live="polite">
  <article
    class="lane-attention-card"
    *ngFor="let alert of alerts; trackBy: trackById"
    [class.lane-attention-card--actionable]="canOpen(alert)"
    [attr.tabindex]="canOpen(alert) ? 0 : null"
    [attr.aria-label]="canOpen(alert) ? alert.title + ' — open chooser' : null"
    (click)="open(alert)"
    (keydown.enter)="onCardEnter(alert, $event)"
    role="status"
  >
    <div class="lane-attention-card__accent" aria-hidden="true"></div>
    <div class="lane-attention-card__body">
      <div class="lane-attention-card__header">
        <h3 class="lane-attention-card__title">{{ alert.title }}</h3>
        <button
          type="button"
          class="lane-attention-card__close"
          aria-label="Dismiss notification"
          (click)="dismiss(alert.id, $event)"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M3 3L11 11M11 3L3 11"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <p class="lane-attention-card__message">{{ alert.message }}</p>
      <div class="lane-attention-card__meta" *ngIf="alert.plate || alert.lane_name || alert.branch">
        <span *ngIf="alert.plate" class="lane-attention-card__chip">{{ plateLabel(alert) }}</span>
        <span *ngIf="alert.lane_name" class="lane-attention-card__chip">{{ alert.lane_name }}</span>
        <span *ngIf="alert.branch" class="lane-attention-card__chip">{{ alert.branch }}</span>
      </div>
      <div class="lane-attention-card__actions" *ngIf="canOpen(alert)">
        <button
          type="button"
          class="lane-attention-card__open"
          (click)="onOpenClick(alert, $event)"
        >
          Open
        </button>
      </div>
    </div>
  </article>
</div>
